
import { supabase } from '../supabase';
import { compressImage, videoTooLarge } from '../imageCompress';

/** Varje uppladdning får ett nytt filnamn, så filen ändras aldrig: webbläsaren får spara den ett år. */
const ONE_YEAR = '31536000';

export const uploadFile = async (bucket: string, original: File) => {
    const tooLarge = videoTooLarge(original);
    if (tooLarge) throw new Error(tooLarge);
    const file = await compressImage(original);

    const fileExt = file.name.split('.').pop();
    const fileName = `${Math.random().toString(36).substring(2)}-${Date.now()}.${fileExt}`;
    const filePath = `${fileName}`;

    const { error: uploadError } = await supabase.storage
        .from(bucket)
        .upload(filePath, file, { cacheControl: ONE_YEAR, contentType: file.type || undefined });

    if (uploadError) throw uploadError;

    const { data } = supabase.storage.from(bucket).getPublicUrl(filePath);
    return data.publicUrl;
};

// Helper to safely parse dates from DB
export const safeDate = (val: any, fallbackVal: any): number => {
    const d1 = val ? new Date(val).getTime() : NaN;
    if (!isNaN(d1)) return d1;

    const d2 = fallbackVal ? new Date(fallbackVal).getTime() : NaN;
    if (!isNaN(d2)) return d2;

    return Date.now();
};
